// extracted by mini-css-extract-plugin
export default {"wrap":"QuizStepperProgress_wrap__9Ja8R","top":"QuizStepperProgress_top__wO+Hv","item":"QuizStepperProgress_item__74-AS","active":"QuizStepperProgress_active__Op-r5"};